/*global chrome*/
import React from "react";
import { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { toastify } from '../../components/Toast';
import { ToastContainer } from 'react-toastify';
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useAnonymousIntercom from "../intercom/useAnonymousIntercom";

function MagicLinkLogin() {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const tokenId = useParams();
    const { search } = useLocation();
    const email = new URLSearchParams(search).get("email") || "";
    const loginRequest = useRef(null);

    useAnonymousIntercom();

    const sendTokenToChromeExtension = ({ extensionId, jwt }) => {
        try {
            if (typeof chrome !== 'undefined' && chrome?.runtime) {
                chrome.runtime.sendMessage(extensionId, { jwt }, response => {
                    // if (!response.success) {
                    //   return response;
                    // }

                });
            }
        } catch (error) {
            console.error(error)
        }
    }
    // A token starts one login request; Strict Mode reuses the pending promise.
    useEffect(() => {
        let active = true;
        let redirectTimer;
        const token = tokenId.id;
        if (!loginRequest.current || loginRequest.current.token !== token) {
            loginRequest.current = {
                token,
                promise: axios.post(process.env.REACT_APP_API + 'users/login-with-magic-link', { token: String(token) })
            };
        }
        setIsLoading(true);
        loginRequest.current.promise.then(response => {
            if (!active) return;
            const session = response?.data?.data;
            if (typeof session?.token !== 'string' || !session.token.trim() ||
                typeof session?.user?._id !== 'string' || !session.user._id.trim()) {
                throw new Error('Invalid login response');
            }
            setIsLoading(false);
            localStorage.setItem('token', session.token);
            localStorage.setItem('userData', JSON.stringify(session.user));
            sendTokenToChromeExtension({ extensionId: process.env.REACT_APP_EXTENSION_ID, jwt: session.token });
            toastify('success', 'Successfully Login');
            redirectTimer = setTimeout(() => navigate('/app/buckets'), 1000);
        }).catch(error => {
            if (!active) return;
            setIsLoading(false);
            const message = error?.response?.data?.message;
            if (message === 'Link has expired' || message === 'Token has been expired') {
                navigate('/?expire=true&email=' + encodeURIComponent(email));
            }
            toastify('error', typeof message === 'string' && message ? message : 'An error occurred');
        });
        return () => {
            active = false;
            clearTimeout(redirectTimer);
        };
    }, [tokenId.id, email, navigate]);

    return (
        <>
            {isLoading ? (
                <div className="App-loading">
                    <div className="App-logo" title="Zimzee" />
                </div>
            ) : (
                <ToastContainer />
            )}
        </>
    );
}

export default MagicLinkLogin;
